export default __webpack_public_path__ + "static/media/mute-sound.67d97142.mp3";